import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";

var _HOST_REFLECT$window$;

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import development from './env.development';
import production from './env.production';
import test from './env.test';
import realpre from './env.realpre';
import hosts from '@/config/hosts';
var envConfig = {
  development: development,
  production: production,
  test: test,
  realpre: realpre
}[process.env.VUE_APP_ENV];
export var HOST_REFLECT = _objectSpread({}, hosts); // 是否二级品牌馆

export var IS_SECONDARY_BRAND = Object.keys(HOST_REFLECT).includes(window.location.host); // 当前二级品牌馆数据

export var CURRENT_SECONDARY_BRAND = ((_HOST_REFLECT$window$ = HOST_REFLECT[window.location.host]) === null || _HOST_REFLECT$window$ === void 0 ? void 0 : _HOST_REFLECT$window$[process.env.VUE_APP_ENV]) || {}; // export const CURRENT_SECONDARY_BRAND = {
//   storeNo: 'ST059004012200001668501873',
//   storeName: '创新生态馆',
//   microHost: 'test-y.ubanquan.cn'
// }

export default _objectSpread(_objectSpread({}, envConfig), {}, {
  appId: 'wxeb44cbdd549b2fb1',
  // 微信订阅号ID
  serviceAppId: 'wx9afbdd727cb19b21' // 微信服务号ID

});